import { EuiLoadingSpinner } from "@elastic/eui"

type Props = {
    size? :'s' | 'm' | 'l' | 'xl' | 'xxl'
}

const LoadingSpinner = ({size} :Props) => <EuiLoadingSpinner size={size}/>

export default LoadingSpinner